import { render, staticRenderFns } from "./SettingsPage.html?vue&type=template&id=ce8815a8&scoped=true&external"
import script from "./SettingsPage.ts?vue&type=script&lang=ts&external"
export * from "./SettingsPage.ts?vue&type=script&lang=ts&external"
import style0 from "./SettingsPage.scss?vue&type=style&index=0&id=ce8815a8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8815a8",
  null
  
)

export default component.exports